import PropTypes from 'prop-types';

import { trans } from '@spotahome/soyuz/client';

import { formatPrice } from '@spotahome/soyuz-currency';

import { ListingCostsShape } from '../../constants/shapes';

import { APPLY_ON_INCLUDED } from '../../constants/costs';

import { DSIcon } from '../../../base';

import InfoBanner from '../InfoBanner';
import openDepositProtectionModal from '../DepositProtectionModal';

import PaymentTimelineCard from './PaymentTimelineCard';
import PaymentTimeLineItem from './PaymentTimelineItem';

import { getUnit, isEstimatedCost } from './costHelpers';

const noop = () => {};

const DEPOSIT_TYPE = 'deposit';
const ELAN_COMPLIANCE_DEPOSIT_NOTE =
  'booking_request.landlord_payments_timeline.elan_compliance_deposit_note';

const OnCheckIn = ({
  hasNoDeposit,
  isPricingCalculated,
  costs = {},
  currencyCode,
  isCollapsed = false,
  onSelectDates = noop,
  hideDepositElanLaw = false
}) => {
  const totalValue =
    costs?.total > 0 ? formatPrice(costs.total, currencyCode) : null;

  const depositTag = hasNoDeposit
    ? {
        label: trans('search.filter.no-deposit.vp.title'),
        renderLeadingIcon: () => <DSIcon name="savings" size="m" />,
        isSpaced: true,
        underlined: true,
        size: 'big'
      }
    : {
        label: trans('homecard.label.deposit.protected'),
        renderLeadingIcon: () => <DSIcon name="lock_closed" size="m" />,
        isSpaced: true,
        underlined: true,
        size: 'big',
        onClick: () => {
          openDepositProtectionModal();
        }
      };

  return (
    <PaymentTimelineCard
      title={trans('payment.timeline.section.on_check_in.title')}
      value={totalValue}
      tags={[depositTag]}
      collapsible
      isCollapsed={isCollapsed}
      onValueClick={!isPricingCalculated ? onSelectDates : null}
      dataTest="spotahomeBookingPaymentInfo.move-in"
    >
      {costs?.costs?.map(cost => {
        if (hideDepositElanLaw && cost.type === DEPOSIT_TYPE) {
          return null;
        }
        return (
          <PaymentTimeLineItem
            key={cost.type}
            title={
              cost.name ?? trans(`payment.timeline.cost.label.${cost.type}`)
            }
            value={cost.value}
            currencyCode={currencyCode}
            included={cost.applyOn === APPLY_ON_INCLUDED}
            tooltipText={cost.description || null}
            unit={getUnit(cost.applyOn)}
            valueSubtitle={
              isEstimatedCost(cost.applyOn)
                ? trans('payment.timeline.estimated-cost')
                : null
            }
            dataTest={`landlordPaymentsTimeline.arrival.${cost.type}`}
          />
        );
      })}
      {hideDepositElanLaw && !hasNoDeposit ? (
        <InfoBanner
          closable={false}
          content={trans(ELAN_COMPLIANCE_DEPOSIT_NOTE)}
          dataTest="landlordPaymentsTimeline.arrival.deposit"
          icon={<DSIcon name="warning_amber" size="m" />}
          theme="warning"
        />
      ) : null}
    </PaymentTimelineCard>
  );
};

OnCheckIn.propTypes = {
  hasNoDeposit: PropTypes.bool.isRequired,
  isPricingCalculated: PropTypes.bool.isRequired,
  costs: ListingCostsShape,
  currencyCode: PropTypes.string.isRequired,
  isCollapsed: PropTypes.bool,
  onSelectDates: PropTypes.func,
  hideDepositElanLaw: PropTypes.bool
};

export default OnCheckIn;
